<template>
  <v-container class="frequency-step-container">
    <v-row dense justify="center" row>
      <v-col class="col-5" center>
        <FrequencyEditor
          v-model="alert.frequency"
          :alert="alert"
        ></FrequencyEditor>
        <ScheduleEditor
          ref="ScheduleEditor"
          v-if="isDaily"
          v-model="alert.schedule"
        ></ScheduleEditor>
        <ExpirationEditor
          v-model="alert.expiration"
          :alert="alert"
        ></ExpirationEditor>
        <SendEmailEditor v-model="alert.sendEmail"></SendEmailEditor>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  FREQUENCY_OPTIONS,
  EXPIRATION_OPTIONS,
} from "@/common/constants/alert.js";
import { validateFrequency } from "@/services/alerts/alert.validation.js";

const EMITTED_ACTIONS = {
  STEP_FINISHED: "stepFinished",
};

export default {
  name: "FrequencyStep",
  components: {
    ScheduleEditor: () =>
      import("@/components/alerts/wizard/schedule/ScheduleEditor"),
    SendEmailEditor: () =>
      import("@/components/alerts/wizard/sendEmail/SendEmailEditor"),
    ExpirationEditor: () =>
      import("@/components/alerts/wizard/expiration/ExpirationEditor"),
    FrequencyEditor: () =>
      import("@/components/alerts/wizard/frequency/FrequencyEditor"),
  },
  props: {
    alert: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  methods: {
    validate() {
      const isValid = validateFrequency(this.alert);
      this.$emit(EMITTED_ACTIONS.STEP_FINISHED, { isValid });
    },
    frequencyChanged() {
      this.alert.schedule = this.alert.frequency.defaultSchedule;
    },
  },
  computed: {
    isDaily() {
      return (
        this.alert &&
        this.alert.frequency &&
        this.alert.frequency.id &&
        this.alert.frequency.id === FREQUENCY_OPTIONS[2].id
      );
    },
  },
  watch: {
    isActive() {
      if (!this.isActive) {
        return;
      }
      this.alert.frequency =
        this.alert.frequency && this.alert.frequency.id
          ? this.alert.frequency
          : FREQUENCY_OPTIONS[0];
      this.alert.schedule = this.alert.schedule
        ? this.alert.schedule
        : this.alert.frequency.defaultSchedule;
      let expToUse =
        this.alert.expiration && this.alert.expiration.id
          ? this.alert.expiration
          : EXPIRATION_OPTIONS[3];
      this.$set(this.alert, "expiration", expToUse);

      this.validate();
    },
    ["alert.frequency"](newValue, oldValue) {
      if (newValue.id !== oldValue.id) {
        this.frequencyChanged();
        this.validate();
      }
    },
    ["alert.schedule"]() {
      this.validate();
    },
    ["alert.expiration"]() {
      this.validate();
    },
    ["alert.sendEmail"]() {
      this.validate();
    },
  },
};
</script>
<style scoped>
.frequency-step-container {
}
</style>
